import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle, XCircle, CircleNotch } from "@phosphor-icons/react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentResult({ type }) {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState(type === "success" ? "checking" : "cancelled");
  const [kind, setKind] = useState("invoice");

  useEffect(() => {
    if (type !== "success" || !sessionId) return;
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`, { withCredentials: true });
        if (data.kind) setKind(data.kind);
        if (data.payment_status === "paid") {
          setStatus("paid");
          return;
        }
      } catch (err) {
        console.warn("Payment status poll failed:", err);
      }
      attempts += 1;
      if (attempts < 10) setTimeout(poll, 2000);
      else setStatus("timeout");
    };
    poll();
  }, [type, sessionId, API]);

  const content = {
    checking: { icon: <CircleNotch size={48} className="animate-spin text-primary" />, title: "Confirming your payment…", body: "Please wait while we verify with Stripe.", testId: "payment-checking" },
    paid: kind === "subscription"
      ? { icon: <CheckCircle size={48} weight="fill" className="text-status-confirmed" />, title: "Subscription active", body: "Your EasyStay Manager subscription has been renewed.", testId: "payment-success" }
      : { icon: <CheckCircle size={48} weight="fill" className="text-status-confirmed" />, title: "Payment received", body: "The invoice has been updated and marked paid.", testId: "payment-success" },
    timeout: { icon: <CircleNotch size={48} className="text-status-pending" />, title: "Still processing", body: "Payment is being confirmed. Check the invoice in a moment.", testId: "payment-timeout" },
    cancelled: { icon: <XCircle size={48} weight="fill" className="text-destructive" />, title: "Payment cancelled", body: "No charge was made. You can try again from the invoice.", testId: "payment-cancelled" },
  }[status];

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-6">
      <div className="w-full max-w-sm border border-border bg-card p-10 text-center" data-testid={content.testId}>
        <div className="flex justify-center">{content.icon}</div>
        <h1 className="font-heading mt-4 text-2xl font-bold">{content.title}</h1>
        <p className="mt-2 text-sm text-muted-foreground">{content.body}</p>
        <Link to={kind === "subscription" ? "/" : "/invoices"} data-testid="payment-back-link"
          className="mt-6 inline-block rounded-sm bg-primary px-5 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90">
          {kind === "subscription" ? "Back to dashboard" : "Back to invoices"}
        </Link>
      </div>
    </div>
  );
}
